"use strict";
exports.__esModule = true;
exports.chart_global_Fill_Color_700 = {
  "name": "--pf-v5-chart-global--Fill--Color--700",
  "value": "#4f5255",
  "var": "var(--pf-v5-chart-global--Fill--Color--700, #4f5255)"
};
exports["default"] = exports.chart_global_Fill_Color_700;